import { useCallback } from "react";
import { MOCK_QUICK_ACTIONS } from "../pages/Accounting/Overview/overviewMockData";
import type { QuickAction } from "../pages/Accounting/Overview/overviewTypes";
import type { QueryResult } from "./types";

/**
 * Returns the Quick actions tiles shown on the Accounting Overview.
 *
 * Quick actions have two layers of data:
 *   - Static navigation metadata (title, description, icon, route) is
 *     frontend-defined and stable across users.
 *   - Dynamic badge counts (e.g., "14 transactions need your eyes")
 *     reflect per-user server state and change over time.
 *
 * Mock behavior (today):
 *   - Returns MOCK_QUICK_ACTIONS with hardcoded badge counts baked
 *     into the mock array.
 *
 * Backend behavior (future):
 *   - Static action metadata stays in a frontend constants file.
 *   - Badge counts are fetched from endpoints like
 *     /api/accounting/unreviewed-count and merged into the action list.
 *   - Components calling useQuickActions() do NOT change.
 */
export function useQuickActions(): QueryResult<QuickAction[]> {
  const refetch = useCallback(() => {
    // No-op in mock. Backend version refetches badge-count queries.
  }, []);

  return {
    data: MOCK_QUICK_ACTIONS,
    loading: false,
    error: null,
    refetch,
  };
}